import { render } from "./payentry.vue?vue&type=template&id=bc0ad3c2&scoped=true"
import script from "./payentry.vue?vue&type=script&lang=js"
export * from "./payentry.vue?vue&type=script&lang=js"

import "./payentry.vue?vue&type=style&index=0&id=bc0ad3c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0ad3c2"]])

export default __exports__